import { api } from '@marketplace-web/core-api/core-api-client-util'

import { ResponseError } from '@marketplace-web/core-api/api-client-util'

import { UpdateVatNumberArgs, UpdateVatNumberResponse } from '../types/vat'

export const updateVatNumber = async ({ vatNumber, countryCode, userId }: UpdateVatNumberArgs) => {
  return api.put<UpdateVatNumberResponse, ResponseError>('/business_accounts/update_vat_number', {
    vat_number: vatNumber,
    country_code: countryCode,
    user_id: userId,
  })
}
